export default __webpack_public_path__ + "static/media/bills1.dbf0e72d.jpg";